<template>
  <div class="health-top">
    <div class="top-right">
      <div class="sleep-top">
        <div class="sleep-title">整体睡眠数据</div>
        <div
          :class="queryType == 0 ? 'days-default' : 'days-active'"
          @click="changeDay(1)"
        >
          过去30天
        </div>
        <div
          :class="queryType == 1 ? 'days-default' : 'days-active'"
          @click="changeDay(0)"
        >
          过去7天
        </div>
        <div class="days-week">
          <a-checkbox @change="onChange">显示周期对比 </a-checkbox>
        </div>
        <!-- <div class="sleep-desc">过去7天</div> -->
        <!-- <div class="sleep-more">查看更多</div> -->
      </div>
      <div class="left">
        <div class="old">
          <div class="old-icon">
            <img src="../../../assets/icon_user.png" alt="" />
          </div>
          <div class="old-num">
            <div class="old-number">
              {{ topData.bedCount || "--" }}
              <img
                v-if="topData.bedCountPercentageState == 1"
                src="../../../assets/redTriangle.png"
                alt=""
              />
			  <img
			    v-if="topData.bedCountPercentageState == 0"
			    src="../../../assets/icon_keep.png"
			    alt=""
			  />
			  <img
			    v-if="topData.bedCountPercentageState == -10"
			    src="../../../assets/greenTriangle.png"
			    alt=""
			  />
			  <img
			    v-if="false"
			    src="../../../assets/icon_keep.png"
			    alt=""
			  />
            </div>
            <div class="old-title">守护老人数量</div>
            <div class="old-desc">
				<span v-if="topData.bedCountPercentageState == 1">较上期上升</span>
				<span v-else-if="topData.bedCountPercentageState == 0">较上期持平</span>
				<span v-else>较上期下降</span>
			  <span v-if="topData.bedCountPercentageState == 1" class="red">{{ topData.bedCountPercentage }}%</span>
			  <span v-else-if="topData.bedCountPercentageState == -1" class="green">{{ topData.bedCountPercentage }}%</span>
			   <span v-else></span>
            </div>
            <div class="old-line"></div>
          </div>
        </div>
        <div class="old" style="margin-top: 10px">
          <div class="old-icon">
            <img src="../../../assets/icon_deepSleep.png" alt="" />
          </div>
          <div class="old-num">
            <div class="old-number">
              {{ topData.sleepScore || "--" }}
              
              <img
                v-if="topData.sleepPercentageState == 1"
                src="../../../assets/redTriangle.png"
                alt=""
              />
			  <img
			    v-if="topData.sleepPercentageState == 0"
			    src="../../../assets/icon_keep.png"
			    alt=""
			  />
			  <img
			    v-if="topData.sleepPercentageState == -1"
			    src="../../../assets/greenTriangle.png"
			    alt=""
			  />
            </div>
            <div class="old-title">睡眠得分中位数</div>
            <div class="old-desc">
				<span v-if="topData.sleepPercentageState == 1">较上期上升</span>
				<span v-else-if="topData.sleepPercentageState == 0">较上期持平</span>
				<span v-else>较上期下降</span>
             <span v-if="topData.sleepPercentageState == 1" class="red">{{ topData.sleepPercentage }}%</span>
			 <span v-else-if="topData.sleepPercentageState == -1" class="green">{{ topData.sleepPercentage }}%</span>
			  <span v-else></span>
            </div>
          </div>
        </div>
      </div>
      <div class="sleep-charts" v-show="visible()">
        <div
          class="sleep-chart"
          id="sleepChartScore"
          style="height: 142px; margin: 10px auto"
          key="sleepChartScore"
        ></div>
        <div
          class="sleep-chart"
          id="sleepChartHealth"
          style="height: 156px; margin: 10px auto"
          key="sleepChartHealth"
        ></div>
        <div
          class="sleep-chart sleep-chart-police"
          id="sleepChartPolice"
          style="height: 156px; margin: 10px auto"
          key="sleepChartPolice"
        ></div>
		<div
		  class="sleep-chart sleep-chart-police2"
		  id="sleepChartPolice2"
		  style="height: 156px; margin: 10px auto"
		  key="sleepChartPolice2"
		></div>
		<div class="chart-name1">睡眠得分</div>
		<div class="chart-name2">呼吸慢病</div>
		<div class="chart-name3">异常报警</div>
      </div>
	  <a-empty v-show="!visible()" description="暂无内容哦" style="margin:10px;"></a-empty>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sleepChartScore: null,
      sleepChartHealth: null,
      sleepChartPolice: null,
	  sleepChartPolice2: null,
      topData: {},
      topEmpty: null,
	  topZero: null, 
      queryType: 0,
      checked: false,
	  aaa: "aaa",
	  leaveBedInterval: 0,
	  nextLeaveBedInterval: 0,
	  healthBigData: [
		  { enable: 0 },
		  { enable: 0 },
		  { enable: 0 },
		  { enable: 0 },
		  { enable: 0 },
		  { enable: 0 },
		  { enable: 0 }
	  ],
    };
  },
  created() {},
  mounted() {
    this.getData();
	this.getHealthBigData();
  },
  methods: {
	getHealthBigData(){
		this.$post('api/health-big-data/select',
			{
				tenantId: this.$getCookie("userInfo").user.tenantId,
			}, res =>{
				if(res.code == 0){
					if(res.data){
						this.healthBigData = res.data;
					}else{
					}
				}else{
					this.$message.error(res.msg);
				}
			}, err => {
				console.log(err);
				this.$message.error('服务端发生异常');
			});
	},
    clearCharts() {
      if (this.sleepChartScore) this.sleepChartScore.clear();
      if (this.sleepChartHealth) this.sleepChartHealth.clear();
      if (this.sleepChartPolice) this.sleepChartPolice.clear();
	  if (this.sleepChartPolice2) this.sleepChartPolice2.clear();
    },
    changeDay(num) {
      this.queryType = num;
      this.getData();
    },
    onChange(e) {
      console.log(`checked = ${e.target.checked}`);
      this.checked = e.target.checked;
      var that = this;
      setTimeout(() => {
        that.clearCharts();
        that.getSleepChartScore();
        that.getSleepChartHealth();
        that.getSleepChartPolice();
		that.getSleepChartPolice2();
      }, 500);
    },
	
    getData() {
      var that = this;
      this.$get(
        "/api/deanData/getWholeSleep",
        { queryType: this.queryType },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              if (!res.data.sleep) {
                res.data.sleep = {};
              }
              if (!res.data.warning) {
                res.data.warning = {};
              }
              if (!res.data.breathing) {
                res.data.breathing = {};
              }

              if (!res.data.nextSleep) {
                res.data.nextSleep = {};
              }
              if (!res.data.nextWarning) {
                res.data.nextWarning = {};
              }
              if (!res.data.nextBreathing) {
                res.data.nextBreathing = {};
              }
              this.topData = res.data;
              setTimeout(() => {
                that.clearCharts();
                that.getSleepChartScore();
                that.getSleepChartHealth();
                that.getSleepChartPolice();
				that.getSleepChartPolice2();
              }, 500);
            } else {
              this.topEmpty = true;
            }
			this.isZero();
          } else {
          }
        },
        (err) => {
          console.log(err);
          this.$message.error("服务端发生异常");
        }
      );
    },
	isZero(){
		var sleep = false;
		var breathing = false;
		var warning = false;
		if(this.topData.sleep.high || 
		  this.topData.sleep.millde || 
		  this.topData.sleep.low) sleep = true;
		if(this.topData.breathing.high ||
		  this.topData.breathing.millde || 
		  this.topData.breathing.low) breathing = true;
		if(this.topData.warning.breathingFast ||
		  this.topData.warning.breathingStop ||
		  this.topData.warning.fall ||
		  this.topData.warning.heartbeatFast ||
		  this.topData.warning.heartbeatSlow || 
		  this.topData.warning.leaveBed) warning = true;
		  this.topZero = !(sleep || breathing || warning);
	},
    goHealth() {
      //   this.$router.push({
      //     path: "/dean/oldHealthy",
      //   });
    },
	setInterval(){
		var i = 10, j = 10;
		for(i; ; i = i * 10){
			if(this.topData.warning.leaveBed / i <= 1) break;
		}
		for(j; ; j = j * 10){
			if(this.topData.nextWarning.leaveBed / j <= 1) break;
		}
		if(this.topData.warning.leaveBed >= i / 10 && this.topData.warning.leaveBed < i / 2) this.leaveBedInterval = i / 10;
		else this.leaveBedInterval = i / 5;
		if(this.topData.nextWarning.leaveBed >= j / 10 && this.topData.nextWarning.leaveBed < j / 2) this.nextLeaveBedInterval = j / 10;
		else this.nextLeaveBedInterval = j / 5;
	},
    //报警图表
    getSleepChartPolice() {
      var that = this;
	  var checked = this.checked;
      //var policeData = this.topData.
      var policeData = [];
      policeData.push(this.topData.warning.leaveBed || 0);
      // policeData.push(this.topData.warning.fall || 0);
      // policeData.push(this.topData.warning.breathingStop || 0);
      // policeData.push(this.topData.warning.breathingFast || 0);
      // policeData.push(this.topData.warning.heartbeatFast || 0);
      // policeData.push(this.topData.warning.heartbeatSlow || 0);

      var nextPoliceData = [];
      nextPoliceData.push(this.topData.nextWarning.leaveBed || 0);
      // nextPoliceData.push(this.topData.nextWarning.fall || 0);
      // nextPoliceData.push(this.topData.nextWarning.breathingStop || 0);
      // nextPoliceData.push(this.topData.nextWarning.breathingFast || 0);
      // nextPoliceData.push(this.topData.nextWarning.heartbeatFast || 0);
      // nextPoliceData.push(this.topData.nextWarning.heartbeatSlow || 0);
      if (this.checked == false) {
        nextPoliceData = [];
      }
      //   policeData.push(this.topData.warning.middle);
      //   policeData.push(this.topData.warning.high);
      this.sleepChartPolice = this.$echarts.init(
        document.getElementById("sleepChartPolice")
      );
      //let colorArr=['#88bafe','#ffa304','#8bbb51','#FB7653','#73D0F7'];
	  this.setInterval();
	  var interval;
	  if(this.topData.warning.leaveBed > this.topData.nextWarning.leaveBed) {
		  if(this.nextLeaveBedInterval == 0) interval = this.leaveBedInterval;
		  else{
			  if(this.leaveBedInterval / this.nextLeaveBedInterval >= 10)
			  	interval = this.leaveBedInterval / 2;
			  else interval = this.leaveBedInterval;
		  }
	  }
	  else{
		  if(this.leaveBedInterval == 0) interval = this.nextLeaveBedInterval;
		  else{
			  if(this.nextLeaveBedInterval / this.leaveBedInterval >= 10)
			  	interval = this.nextLeaveBedInterval / 2;
			  else interval = this.nextLeaveBedInterval;
		  }
	  }
      var option = {
        color: this.checked ? ["#B9DDFF", "#1890FF"] : ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
		  formatter: function (params) {
		  	  var res = "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" + params[0].name + " </p></div>";
		  				if(checked){
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">上周期  <strong>${params[0].data}</strong>次</span>
		  						</div>`;
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[1].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[1].data}</strong>次</span>
		  						</div>`;
		  				}else{
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[0].data}</strong>次</span>
		  						</div>`;
		  				}
		  		
		  	  return res;
		  	},
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            // name: "异常报警", //坐标名字
            // nameLocation: "end", //坐标位置，支持start,end，middle
            // nameTextStyle: {
            //   padding: [10, 0, 0, 0], // 四个数字分别为上右下左与原位置距离
            // },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
              formatter: function (val) {
                var strs = val.split(""); //字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s;
                  if (!(i % 4)) str += "\n";
                }
                return str;
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: [
              "离床报警次数",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",

            splitLine: {
              show: false,
            },
            z: 10,
            minInterval: interval,
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [],
      };

      var last = {
        name: "上周期",
        type: "bar",
        barGap: 0,
        barWidth: 17,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: nextPoliceData,
      };

      var week = {
        name: "本周期",
        type: "bar",
        //barGap: 0,
        barWidth: 17,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: policeData,
      };
      if (this.checked) {
        option.series.push(last);
      }
      option.series.push(week);
      this.sleepChartPolice.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartPolice.resize();
      });
    },
	getSleepChartPolice2() {
	  var that = this;
	  var checked = this.checked;
	  //var policeData = this.topData.
	  var policeData = [];
	  // policeData.push(this.topData.warning.leaveBed || 0);
	  policeData.push(this.topData.warning.fall || 0);
	  policeData.push(this.topData.warning.breathingStop || 0);
	  policeData.push(this.topData.warning.breathingFast || 0);
	  policeData.push(this.topData.warning.heartbeatFast || 0);
	  policeData.push(this.topData.warning.heartbeatSlow || 0);
	
	  var nextPoliceData = [];
	  // nextPoliceData.push(this.topData.nextWarning.leaveBed || 0);
	  nextPoliceData.push(this.topData.nextWarning.fall || 0);
	  nextPoliceData.push(this.topData.nextWarning.breathingStop || 0);
	  nextPoliceData.push(this.topData.nextWarning.breathingFast || 0);
	  nextPoliceData.push(this.topData.nextWarning.heartbeatFast || 0);
	  nextPoliceData.push(this.topData.nextWarning.heartbeatSlow || 0);
	  if (this.checked == false) {
	    nextPoliceData = [];
	  }
	  //   policeData.push(this.topData.warning.middle);
	  //   policeData.push(this.topData.warning.high);
	  this.sleepChartPolice2 = this.$echarts.init(
	    document.getElementById("sleepChartPolice2")
	  );
	  //let colorArr=['#88bafe','#ffa304','#8bbb51','#FB7653','#73D0F7'];
	  var option = {
	    color: this.checked ? ["#B9DDFF", "#1890FF"] : ["#1890FF"],
	    tooltip: {
	      backgroundColor: "rgba(255, 255, 255, 0.9)",
	      borderColor: "rgba(24, 144, 255, 0.8)",
	      borderRadius: 5,
	      show: true,
	      trigger: "axis",
		  formatter: function (params) {
		  	  var res = "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" + params[0].name + " </p></div>";
		  				if(checked){
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">上周期  <strong>${params[0].data}</strong>次</span>
		  						</div>`;
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[1].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[1].data}</strong>次</span>
		  						</div>`;
		  				}else{
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[0].data}</strong>次</span>
		  						</div>`;
		  				}
		  		
		  	  return res;
		  	},
	    },
	    grid: {
	      left: "1%",
	      right: "1%",
	      top: "8%",
	      bottom: "0%",
	      containLabel: true,
	    },
	    xAxis: [
	      {
	        type: "category",
	        axisTick: { show: false },
	        // name: "异常报警", //坐标名字
	        // nameLocation: "end", //坐标位置，支持start,end，middle
	        // nameTextStyle: {
	        //   padding: [10, 0, 0, 0], // 四个数字分别为上右下左与原位置距离
	        // },
	        axisLabel: {
	          textStyle: {
	            color: "rgba(0,0,0,0.35)", //坐标的字体颜色
	          },
	          interval: 0,
	          formatter: function (val) {
	            var strs = val.split(""); //字符串数组
	            var str = "";
	            for (var i = 0, s; (s = strs[i++]); ) {
	              //遍历字符串数组
	              str += s;
	              if (!(i % 4)) str += "\n";
	            }
	            return str;
	          },
	        },
	        axisLine: {
	          lineStyle: {
	            color: "rgba(0,0,0,0.15)",
	          },
	        },
	        // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
	        data: [
	          "跌倒次数",
	          "呼吸暂停过久",
	          "呼吸过速",
	          "心跳过速",
	          "心跳过缓",
	        ],
	      },
	    ],
	    yAxis: [
	      {
	        type: "value",
	
	        splitLine: {
	          show: false,
	        },
	        z: 10,
	        minInterval: 10, //设置最小间隔为1，防止出现小数
	        axisLine: {
	          lineStyle: {
	            color: "rgba(0,0,0,0.15)",
	          },
	          show: true,
	        },
	        axisTick: {
	          //y轴刻度线
	          show: false,
	        },
	        axisLabel: {
	          textStyle: {
	            color: "rgba(0,0,0,0.35)", //坐标的字体颜色
	          },
	          margin: 5,
	          show: true,
	        },
	      },
	    ],
	    series: [],
	  };
	
	  var last = {
	    name: "上周期",
	    type: "bar",
	    barGap: 0,
	    barWidth: 17,
	    // barCategoryGap: 1,
	    itemStyle: {
	      normal: {
	        //柱形图圆角，初始化效果
	        barBorderRadius: [0, 0, 0, 0],
	      },
	    },
	    data: nextPoliceData,
	  };
	
	  var week = {
	    name: "本周期",
	    type: "bar",
	    //barGap: 0,
	    barWidth: 17,
	    // barCategoryGap: 1,
	    itemStyle: {
	      normal: {
	        //柱形图圆角，初始化效果
	        barBorderRadius: [0, 0, 0, 0],
	      },
	    },
	    data: policeData,
	  };
	  if (this.checked) {
	    option.series.push(last);
	  }
	  option.series.push(week);
	  this.sleepChartPolice2.setOption(option);
	  window.addEventListener("resize", () => {
	    this.sleepChartPolice2.resize();
	  });
	},
    //呼吸慢病图表
    getSleepChartHealth() {
      var that = this;
	  var checked = this.checked;
      var healthData = [];
      healthData.push(this.topData.breathing.low || 0);
      healthData.push(this.topData.breathing.middle || 0);
      healthData.push(this.topData.breathing.high || 0);
      var nextHealthData = [];
      nextHealthData.push(this.topData.nextBreathing.low || 0);
      nextHealthData.push(this.topData.nextBreathing.middle || 0);
      nextHealthData.push(this.topData.nextBreathing.high || 0);
      if (this.checked == false) {
        nextHealthData = [];
      }
      this.sleepChartHealth = this.$echarts.init(
        document.getElementById("sleepChartHealth")
      );
      var option = {
        color: this.checked ? ["#B9DDFF", "#1890FF"] : ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
		  formatter: function (params) {
		  	  var res = "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" + params[0].name + " </p></div>";
		  				if(checked){
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">上周期  <strong>${params[0].data}</strong>人次</span>
		  						</div>`;
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[1].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[1].data}</strong>人次</span>
		  						</div>`;
		  				}else{
		  					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
		  						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
		  						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[0].data}</strong>人次</span>
		  						</div>`;
		  				}
		  		
		  	  return res;
		  	},
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },

            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
              formatter: function (val) {
                var strs = val.split(""); //字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s;
                  if (!(i % 3)) str += "\n";
                }
                return str;
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: ["疑似低风险", "疑似中风险", "疑似高风险"],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            z: 10,
            // max: 30,
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [],
      };
      var last = {
        name: "上周期",
        type: "bar",
        barGap: 0,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: this.healthBigData[3].enable == 1 ? nextHealthData : [0, 0, 0],
      };
      var week = {
        name: "本周期",
        type: "bar",
        barWidth: 17,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: this.healthBigData[3].enable == 1 ? healthData : [0, 0, 0],
      };

      if (this.checked) {
        option.series.push(last);
      }
      option.series.push(week);
	
      this.sleepChartHealth.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartHealth.resize();
      });
    },
    //得分图表
    getSleepChartScore() {
      var that = this;
      var scoreData = [];
      scoreData.push(this.topData.sleep.low || 0);
      scoreData.push(this.topData.sleep.middle || 0);
      scoreData.push(this.topData.sleep.high || 0);

      var nextScoreData = [];
      nextScoreData.push(this.topData.nextSleep.low || 0);
      nextScoreData.push(this.topData.nextSleep.middle || 0);
      nextScoreData.push(this.topData.nextSleep.high || 0);
      if (this.checked == false) {
        nextScoreData = [];
      }
      this.sleepChartScore = this.$echarts.init(
        document.getElementById("sleepChartScore")
      );
	  var checked = this.checked;
      var option = {
        color: this.checked ? ["#B9DDFF", "#1890FF"] : ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
		  formatter: function (params) {
		  	  var res = "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" + params[0].name + " </p></div>";
				if(checked){
					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
						<span style="font-size:14px;opacity:0.6;">上周期  <strong>${params[0].data}</strong>人次</span>
						</div>`;
					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[1].color, ]};"></span>
						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[1].data}</strong>人次</span>
						</div>`;
				}else{
					res +=  `<div style="color: #000;font-size: 8px;line-height: 16px">
						<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[params[0].color, ]};"></span>
						<span style="font-size:14px;opacity:0.6;">本周期  <strong>${params[0].data}</strong>人次</span>
						</div>`;
				}
		  		
		  	  return res;
		  	},
		  
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },

            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: ["0~59", "60~84", "85及以上"],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            z: 10,
            // max: 300,
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [],
      };
      var last = {
        name: "上周期",
        type: "bar",
        barGap: 0,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: this.healthBigData[3].enable == 1 ? nextScoreData : [0, 0, 0],
      };
      var week = {
        name: "本周期",
        type: "bar",
        barWidth: 17,
        // barCategoryGap: 1,
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [0, 0, 0, 0],
          },
        },
        data: this.healthBigData[3].enable == 1 ? scoreData : [0, 0, 0],
      };
      if (this.checked) {
        option.series.push(last);
      }
      option.series.push(week);
      this.sleepChartScore.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartScore.resize();
      });
    },
	visible: function(){
		return !(this.topEmpty || this.topZero || 0);
	},
  },
};
</script>
<style lang="scss" scoped>
.health-top {
  width: 100%;
  height: 258px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  .top-left {
    width: 170px;
    height: 220px;
    display: inline-block;
  }
  .top-right {
    width: 1200px;
    height: 240px;
    background: white;
    border-radius: 8px;
    display: inline-block;
    margin-left: 0px;
    .left {
      height: 150px;
      float: left;
      margin-top: 20px;
      .old-line {
        border-bottom: 1px dashed #ccc;
        width: 140px;
        height: 10px;
        position: relative;
        left: -40px;
      }
      .old {
        width: 170px;
        height: 80px;
        background: white;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .old-icon {
          margin-left: 15px;
          img {
            width: 30px;
            position: relative;
            top: -20px;
          }
        }
        .old-num {
          margin-left: 20px;
          width: 110px;
          text-align: left;
          .old-number {
            color: #262626;
            line-height: 42px;
            font-size: 38px;
            font-weight: 300;
            img {
              width: 15px;
            }
          }
          .old-title {
            color: #8c8c8c;
            line-height: 20px;
            font-size: 12px;
            margin-top: 0px;
          }
          .old-desc {
            color: #262626;
            line-height: 20px;
            font-size: 14px;
			width: 110px;
            .green {
              color: #52c41a;
            }
			.red {
			  color: #ff4d4f;
			}
          }
        }
      }
      .score {
        margin-top: 10px;
        width: 170px;
        height: 105px;
        background: white;
        border-radius: 8px;
      }
    }
    .sleep-top {
      width: 100%;
      .days-default {
        float: right;
        width: 83px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        color: #262626;
        line-height: 29px;
        font-size: 14px;
        text-align: center;
        margin: 10px 10px 0 0px;
        cursor: pointer;
      }
      .days-active {
        float: right;
        width: 83px;
        height: 32px;
        background: #e6f7ff;
        border-radius: 2px;
        color: #1890ff;
        line-height: 29px;
        font-size: 14px;
        text-align: center;
        margin: 10px 10px 0 0px;
        cursor: pointer;
        border: 1px solid #1890ff;
      }
      .days-week {
        float: right;
        margin: 15px 5px  0 0;
		
      }
	  
      .sleep-title {
        font-size: 16px;
        color: #262626;
        line-height: 20px;
        display: inline-block;
        margin: 15px 0 0 15px;
      }
      .sleep-desc {
        color: #8c8c8c;
        line-height: 14px;
        font-size: 10px;
        display: inline-block;
        margin-left: 8px;
        position: relative;
        top: 2px;
      }
      .sleep-more {
        float: right;
        position: relative;
        top: 15px;
        right: 15px;
        color: #1890ff;
        line-height: 18px;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .sleep-charts {
      width: 950px;
      margin: 0 15px;
      height: 180px;
      display: inline-block;
      .sleep-chart {
        width: 250px;
        // display: inline-block;
        float: left;
      }
      .sleep-chart-police {
		width: 100px;
		
      }
	  .sleep-chart-police2 {
	  	width: 350px;
	  }
	 
	  .chart-name1 {
	    width: 250px;
	    height:5%;
	    position: relative;
	    bottom:8px;
	    text-align:center;
		font-size: 10px;
	    color:rgba(0,0,0,0.35);
	  }
	  .chart-name2 {
	    width: 250px;
	    height:5%;
	    position: relative;
	    left: 250px;
	    bottom:8px;
	    text-align:center;
		font-size: 10px;
	    color:rgba(0,0,0,0.35);
	  }
	  .chart-name3 {
	    width: 350px;
	    height:5%;
	    position: relative;
	    left: 600px;
	    bottom:8px;
	    text-align:center;
		font-size: 10px;
	    color:rgba(0,0,0,0.35);
	  }
    }
  }
}
</style>